/* eslint-disable camelcase */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  TextField,
  Box,
  Typography,
  useTheme
} from '@mui/material';
import RelaunchCustomerRelaunchComment from './RelaunchCustomerRelaunchComment';
import CustomerProInfos from '../customer/CustomerProInfos';
import { alpha } from '@mui/material/styles';

const RelaunchCustomerProDetails = (props) => {
  const { profession, specialite, modeOfExercise, adeliRpps, numSecu, mdpMondpc, comment_commercial, comment_relance, antecedents, editing, remplacant, siret, mdpFifpl, startRelaunchDate,
    // eslint-disable-next-line react/prop-types
    errors, handleBlur, handleChange, touched, values, setFieldValue, callTrack, callTrackRelance, callTrackRelanceList, customer, formations, customerId,
    campaignId, setIsTreated, saveTime, commentRelance, setCommentRelance, ...other } = props;

  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Card 
        {...other}
        sx={{
          borderRadius: '24px',
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.paper',
          backdropFilter: 'blur(20px)',
          boxShadow: (theme) => `0 8px 32px ${alpha(theme.palette.common.black, 0.02)}`,
          overflow: 'hidden'
        }}
      >
        <CardHeader title="Informations professionnelles" sx={{ px: 3, py: 2 }} />
        <Divider />
        <CustomerProInfos
          remplacant={remplacant}
          mdpFifpl={mdpFifpl}
          mdpMondpc={mdpMondpc}
          editing={editing}
          errors={errors}
          touched={touched}
          callTrackRelanceList={callTrackRelanceList}
          callTrackRelance={callTrackRelance}
          callTrack={callTrack}
          startRelaunchDate={startRelaunchDate}
          setFieldValue={setFieldValue}
          values={values}
          handleChange={handleChange}
          handleBlur={handleBlur}
          siret={siret}
          adeliRpps={adeliRpps}
          modeOfExercise={modeOfExercise}
          specialite={specialite}
          profession={profession}
        />
      </Card>
      
      <RelaunchCustomerRelaunchComment
        comment_relance={comment_relance}
        customer={customer}
        formations={formations}
        customerId={customerId}
        setIsTreated={setIsTreated}
        saveTime={saveTime}
        commentRelance={commentRelance}
        setCommentRelance={setCommentRelance}
      />
      
      <Card
        sx={{
          borderRadius: '24px',
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.paper',
          backdropFilter: 'blur(20px)',
          boxShadow: (theme) => `0 8px 32px ${alpha(theme.palette.common.black, 0.02)}`,
          overflow: 'hidden',
          minHeight: 195
        }}
      >
        <CardHeader title="Antécédents" sx={{ px: 3, py: 2 }} />
        <Divider />
        <CardContent sx={{ p: 3 }}>
          {editing ? (
            <TextField
              multiline
              rows={4}
              fullWidth
              placeholder="Entrer des antécédents"
              name="antecedents"
              value={values.antecedents || ''}
              onBlur={handleBlur}
              onChange={handleChange}
              InputProps={{ sx: { borderRadius: '12px' } }}
            />
          ) : (
            <Typography variant="body2" sx={{ color: antecedents ? 'text.primary' : 'text.secondary', fontStyle: antecedents ? 'normal' : 'italic' }}>
              {antecedents || 'Aucun antécédent renseigné.'}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

RelaunchCustomerProDetails.propTypes = {
  profession: PropTypes.string.isRequired,
  specialite: PropTypes.string.isRequired,
  modeOfExercise: PropTypes.string.isRequired,
  adeliRpps: PropTypes.string,
  numSecu: PropTypes.string,
  mdpMondpc: PropTypes.string,
  comment_commercial: PropTypes.object,
  comment_relance: PropTypes.object,
  callTrack: PropTypes.string,
  callTrackRelance: PropTypes.string,
  callTrackRelanceList: PropTypes.array,
  antecedents: PropTypes.string,
  editing: PropTypes.bool,
  touched: PropTypes.object,
  errors: PropTypes.object,
  values: PropTypes.object,
  customer: PropTypes.object,
  formations: PropTypes.array,
  customerId: PropTypes.string,
  campaignId: PropTypes.string,
  setIsTreated: PropTypes.func,
  saveTime: PropTypes.func,
  commentRelance: PropTypes.object,
  setCommentRelance: PropTypes.func,
  mdpFifpl: PropTypes.string,
  remplacant: PropTypes.bool,
  siret: PropTypes.string,
  startRelaunchDate: PropTypes.string
};

export default RelaunchCustomerProDetails;
